import React, { useState } from 'react';

const faqs = [
  {
    question: 'What types of functional support do you provide for Infor M3?',
    answer:
      'We provide comprehensive functional support across all Infor M3 modules including manufacturing, supply chain management, distribution, finance, procurement, inventory management, quality management, project management, and service management. Our support covers system configuration, process optimization, user issue resolution, and continuous improvement initiatives.',
  },
  {
    question: 'Do you help with Infor M3 system health checks and performance reviews?',
    answer:
      'Yes. We conduct thorough system health checks covering current configuration, workflows, reports, data quality, integrations, performance metrics, and user adoption. Our reviews identify practical improvement areas to optimize system performance, enhance user productivity, and ensure your M3 environment operates at peak efficiency.',
  },
  {
    question: 'Can you support Infor M3 implementations or new rollouts?',
    answer:
      'Absolutely. We provide end-to-end implementation support including project planning, business process blueprinting, system configuration, data migration, integration testing, user training, go-live readiness assessment, and post-go-live stabilization. Our methodology ensures smooth deployments with minimal business disruption.',
  },
  {
    question: 'Do you offer training and documentation for Infor M3?',
    answer:
      'Yes. We create comprehensive role-based training programs, detailed process documentation, user guides, practice scenarios, and standard operating procedures (SOPs) for both business and technical users. Our training ensures your teams are confident and proficient in using Infor M3 capabilities.',
  },
  {
    question: 'What is your approach to resolving complex Infor M3 issues?',
    answer:
      'We follow a structured approach that includes analyzing the business process, reviewing system configuration, examining data flow, assessing integration points, and understanding user impact. We then develop clear recommendations for functional or technical resolution, ensuring issues are addressed systematically and permanently.',
  },
  {
    question: 'Can PT KCS Tech support integrations involving Infor M3?',
    answer:
      'Yes. We help design, validate, troubleshoot, and improve integrations between Infor M3 and surrounding systems including ERP applications, WMS, CRM, e-commerce platforms, EDI systems, reporting tools, and operational systems. Our integration expertise ensures reliable data flow and seamless process synchronization.',
  },
  {
    question: 'Do you provide ongoing support and maintenance for Infor M3?',
    answer:
      'Yes. We offer comprehensive ongoing support including 24/7 application support, incident management, performance monitoring, preventive maintenance, and SLA-based support. Our managed services ensure your Infor M3 environment remains stable, secure, and optimized for your business needs.',
  },
  {
    question: 'Do you support Infor M3 upgrades and cloud migration?',
    answer:
      'Yes. We provide complete upgrade and cloud migration services including version upgrades, feature enhancements, system modernization, performance optimization, and upgrade testing. Our team manages the entire process from assessment through deployment to ensure a smooth transition with minimal business impact.',
  },
];

const M3FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((currentIndex) => (currentIndex === index ? null : index));
  };

  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8 lg:py-12 bg-[#ffffff]">
      <div className="mx-auto max-w-7xl">
        <h2 className="mb-12 text-center text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl md:text-4xl">
          Frequently Asked Questions
        </h2>

        <div className="mx-auto max-w-4xl space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={faq.question}
                className="overflow-hidden rounded-xl border transition-all duration-200"
                style={{
                  backgroundColor: '#FFFFFF',
                  borderColor: isOpen ? '#4B5563' : '#E2E8F0',
                  boxShadow: isOpen ? '0 4px 20px rgba(14, 165, 164, 0.1)' : 'none',
                }}
              >
                <button
                  type="button"
                  onClick={() => toggleFaq(index)}
                  className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left"
                  aria-expanded={isOpen}
                >
                  <span 
                    className="text-lg font-semibold transition-colors duration-200"
                    style={{ color: isOpen ? '#4B5563' : '#1A2634' }}
                  >
                    {faq.question}
                  </span>
                  <span 
                    className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-xl font-bold transition-colors duration-200"
                    style={{ 
                      backgroundColor: isOpen ? '#4B5563' : '#F1F5F9',
                      color: isOpen ? '#FFFFFF' : '#64748B'
                    }}
                  >
                    {isOpen ? '-' : '+'}
                  </span>
                </button>

                <div
                  className={`transition-all duration-300 ease-in-out ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-6 pb-6 text-base leading-7 text-gray-600">
                    {faq.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default M3FAQ;